export default __webpack_public_path__ + "img/e305cd62e0428dfc54ee81d4b575d9a3.png";